<template>
    <div v-if="!loading" class="w-full h-full fixed pt-[10px] bottom-0 z-[999] bg-[#FFF]">
        <div @click="$emit('close')" class="flex text-[#4A4E69] items-center ml-3 mt-2">
            <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 17L1.56957 10.8258C0.810144 10.0966 0.810144 8.90341 1.56957 8.17424L8 2" stroke="#22223B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>
            <div class="ml-2 text-[#4A4E69]">
                Назад
            </div>
        </div>

        <div class="border-b-[1px] border-[#4A4E69] pb-2 text-gray-emb text-[20px] font-bold text-center w-[90%] mx-auto">
            {{ training.date.split('T')[0].split('-').reverse().join('.') }}
        </div>

        <div class="w-full flex justify-center mt-[20px]">
            <div class="">

            </div>
        </div>
        <div class="w-full flex justify-center mt-[100px]">
            <div class="text-[#6BA292]" style="font-size: 20px; font-weight: 800; line-height: 20px; letter-spacing: 0em; text-align: center;">
                ви обрали запис на<br>тренування: 
            </div>
        </div>

        <SquircleComponent
            class="mt-[34px] relative bg-[#DBEBEA] mx-auto"
            :smooth="70" 
            :radius="44" 
            :width="354" 
            :height="78" 
            :outlineWidth="0"
        >
                <div class="flex text-[#4A4E69] relative top-[15px] items-center ml-[10px] mr-[16px] ">
                    <div class="w-full pt-[3px] flex items-center">
                        <div class="w-[52.1px] h-[44px] mr-[10px] relative bottom-[5px] rounded-full overflow-hidden border-[2px] border-[#525A60] ">
                            <img v-if="training?.trainer_photo" class="w-full h-full bg-white " :src="apiURL + 'static/' + training?.trainer_photo">
                            <div v-else class="h-full w-full flex justify-center items-center text-gray-emb bg-gray-emb bg-opacity-20">{{ training.trainer_label.split(' ')[0][0].toUpperCase() + training.trainer_label.split(' ')[1][0].toUpperCase() }}</div>
                        </div>
                        <div class="w-full mt-[px]">
                            <div class="w-full border-b-[0.2px] border-[#fff] border-opacity-20 pb-[10px]">
                            <div class="flex w-full">
                                <!-- <div class="font-bold relative text-[16px] text-gray-emb bottom-[5px] w-[37%] truncate">{{ training.trainer_label.split(' ')[0] + ' ' + training.trainer_label.split(' ')[1][0] + '.'  }}</div> -->
                                <div class="font-bold relative text-[16px] text-gray-emb bottom-[5px] ">{{ parseType(training.type)  }}</div>
                                <div class="font-bold text-[13px] relative text-gray-emb bottom-[1px] ml-[10px]">{{ training.tariff_group_name ? translateGroupName(training.tariff_group_name) : 'PER/SPLIT'  }}</div>
                            </div>
                            <div class="flex justify-start w-full">
                                <div class="flex w-[37%] relative top-[6px]">
                                    <div class="text-[11px] text-gray-emb">{{ training.start_time }}</div>
                                    <div class="mx-[5px] text-[11px] text-gray-emb">
                                        <svg class="scale-50 origin-center relative top-[1px]" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 11L5.29289 6.70711C5.62623 6.37377 5.79289 6.20711 5.79289 6C5.79289 5.79289 5.62623 5.62623 5.29289 5.29289L1 1" stroke="#22223B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div class="text-[11px] text-gray-emb">{{ training.end_time }}</div>
                                </div>
                                <div class="text-start text-[11px] relative top-[6px] truncate">{{ training.trainer_label.split(' ')[0] + ' ' + training.trainer_label.split(' ')[1][0] + '.'  }} </div>
    
                                <div class="flex ml-auto mt-[-13px]">
                                    <div class="text-[11px] w-[55px] mt-[4px] text-gray-emb">
                                        <!-- {{training.location_label}} -->
                                    </div>
                                    <div 
                                        class="truncate text-[#6BA292] font-bold w-[30px] text-start"
                                        :class="{
                                            'text-[#6BA292]' : training.clientsCount < training.max_clients,
                                            'text-[#BF637D]' : training.clientsCount >= training.max_clients
                                        }"    
                                    >{{ training.clientsCount }}/{{ training.max_clients }}</div>
                                    <div 
                                        class="h-[22px] w-[22px] border-[2px] ml-[5px] rounded-full"
                                        :class="{
                                            'bg-[#6BA292] border-[#6BA292]' : training.clientsCount < training.max_clients,
                                            'bg-[#BF637D] border-[#BF637D]' : training.clientsCount >= training.max_clients
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

        <!-- <SquircleComponent
                :smooth="70" 
                :radius="40" 
                :width="350" 
                :height="75" 
                :outlineWidth="1"
                class="bg-[#E7F1F1] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
            >

            </SquircleComponent> -->
        </SquircleComponent>

        <div v-if="clientAvalaibelBooks > 0 && currentTarrifDateExpire >= trainingDate && ((currentTarriff?.tarrif_group_name == 'PERSONAL' && (training.tariff_group_name == 'PERSONAL' || training.tariff_group_name == 'SPLIT' || training.tariff_group_name == 'TEAM')) || (currentTarriff?.tarrif_group_name == 'SPLIT' && (training.tariff_group_name == 'SPLIT' || training.tariff_group_name == 'TEAM')) || (currentTarriff?.tarrif_group_name == 'TEAM' && training.tariff_group_name == 'TEAM'))" class="w-full flex flex-col items-center justify-center mt-[200px]">
            <div class="text-[#BF637D] text-center px-[30px] text-[13px]">
                у вас буде можливість скасувати запис не пізніше, ніж за <span v-if="training.tariff_group_name !='TEAM'">12</span><span v-else>6</span> годин до початку цього тренування
            </div>
        </div>

        <div v-if="clientAvalaibelBooks <= 0 && currentTarrifDateExpire >= trainingDate" class="w-full flex flex-col items-center justify-center mt-[200px]">
            <div class="text-[#BF637D] text-center px-[30px] text-[13px]">
                у вас не залишилось вільних бронювань за поточним абонементом
            </div>

            <button 
                v-if="
                    isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'PERSONAL') ||
                    isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'PERSONAL')
                "
                class="bg-green-emb disabled:opacity-50 mx-auto left-[50%] w-[363px] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center mb-[16px]"
                @click="$router.push('/payment-view?tariffGroup=PERSONAL')"
            >
                <div class="w-full text-[13px] text-gray-emb font-extrabold">Так, придбати</div>
            </button>
            <button 
                v-if="
                    isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'SPLIT') ||
                    isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'SPLIT') ||
                    training.superposition
                "
                class="bg-green-emb disabled:opacity-50 mx-auto left-[50%] w-[363px] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center mb-[16px]"
                @click="$router.push('/payment-view?tariffGroup=SPLIT')"
            >
                <div class="w-full text-[13px] text-gray-emb font-extrabold">Так, придбати</div>
            </button>
            <button 
                v-if="
                    isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'TEAM') ||
                    isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'TEAM')
                "
                class="bg-green-emb disabled:opacity-50 mx-auto left-[50%] w-[363px] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center mb-[16px]"
                @click="$router.push('/payment-view?tariffGroup=TEAM')"
            >
                <div class="w-full text-[13px] text-gray-emb font-extrabold">Так, придбати</div>
            </button>
            <button @click="$emit('close')" class="bg-rose-emb disabled:opacity-50 mx-auto left-[50%] w-[363px] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center mb-[16px]">
                <div class="w-full text-[13px] text-gray-emb font-extrabold">Ні, скасувати</div>
            </button>
        </div>

        <!-- <div v-if="currentTarrifDateExpire <= trainingDate && clientAvalaibelBooks > 0" class="w-full flex flex-col items-center justify-center mt-[200px]">
            <div class="text-[#BF637D] text-center px-[30px] text-[13px]">
                термін дії вашого абонементу не покриває це тренування
            </div>
        </div> -->
        <div v-if="currentTarrifDateExpire <= trainingDate" class="w-full flex flex-col items-center justify-center mt-[200px]">
            <!-- <div v-if="currentTarrifDateExpire <= trainingDate" class="text-[#BF637D] text-center px-[30px] text-[13px] mb-[20px]">
                Термін дії вашого абонементу не поширюється на це тренування. Чи бажаєте ви придбати абонемент?
            </div>
            <div v-else class="text-[#BF637D] text-center px-[30px] text-[13px] mb-[20px]">
                Наразі у Вас немає діючого абонементу для здійснення запису на тренування. Чи бажаєте ви придбати абонемент?
            </div> -->

            <div v-if="tarriffsCount == 2" class="text-[#BF637D] text-center px-[30px] text-[13px] mb-[20px]">
                Наразі у Вас немає діючого абонементу для здійснення запису на тренування. Чи бажаєте ви придбати абонемент?
            </div>
            <div v-else class="text-[#BF637D] text-center px-[30px] text-[13px] mb-[20px]">
                Термін дії вашого абонементу не поширюється на це тренування. Чи бажаєте ви придбати абонемент?
            </div>

            <button 
                v-if="
                    isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'PERSONAL') ||
                    isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'PERSONAL')
                "
                class="bg-green-emb disabled:opacity-50 mx-auto left-[50%] w-[363px] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center mb-[16px]"
                @click="$router.push('/payment-view?tariffGroup=PERSONAL')"
            >
                <div class="w-full text-[13px] text-gray-emb font-extrabold">Так, придбати</div>
            </button>
            <button 
                v-if="
                    isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'SPLIT') ||
                    isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'SPLIT') ||
                    training.superposition
                "
                class="bg-green-emb disabled:opacity-50 mx-auto left-[50%] w-[363px] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center mb-[16px]"
                @click="$router.push('/payment-view?tariffGroup=SPLIT')"
            >
                <div class="w-full text-[13px] text-gray-emb font-extrabold">Так, придбати</div>
            </button>
            <button 
                v-if="
                    isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'TEAM') ||
                    isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'TEAM')
                "
                class="bg-green-emb disabled:opacity-50 mx-auto left-[50%] w-[363px] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center mb-[16px]"
                @click="$router.push('/payment-view?tariffGroup=TEAM')"
            >
                <div class="w-full text-[13px] text-gray-emb font-extrabold">Так, придбати</div>
            </button>
            <button @click="$emit('close')" class="bg-rose-emb disabled:opacity-50 mx-auto left-[50%] w-[363px] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center mb-[16px]">
                <div class="w-full text-[13px] text-gray-emb font-extrabold">Ні, скасувати</div>
            </button>
        </div>

        <!-- <div v-if="currentTarriff?.tarrif_group_name != training.tariff_group_name" class="w-full flex flex-col items-center justify-center">
            <div v-if="isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name)" class="text-[#BF637D] text-center px-[30px] text-[13px] mt-[20px]">
                Бажаєте дане тренування списати з Вашого діючого абонементу, чи оплатити його, купивши абонемент з переліку нижче? 
            </div>
            <div v-if="isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name)" class="text-[#BF637D] text-center px-[30px] text-[13px] mt-[200px]">
                Дія Вашого абонементу не поширюється  на даний тип тренування. Чи бажаєте придбати абонемент з переліку нижче, щоб здійснити запис на обране заняття?
            </div>
            <div class="tariff-group-recommendation flex gap-[10px] mt-[10px]">
                <div 
                    v-if="
                        isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'PERSONAL') ||
                        isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'PERSONAL')
                    "
                    class="text-[12px] bg-rose-emb rounded-md text-center text-gray-emb px-[3px] py-[2px] w-[100px]"
                    @click="$router.push('/payment-view?tariffGroup=PERSONAL')"
                >PERSONAL</div>
                <div 
                    v-if="
                        isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'SPLIT') ||
                        isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'SPLIT')
                    "
                    class="text-[12px] bg-green-emb rounded-md text-center text-gray-emb px-[3px] py-[2px] w-[100px]" 
                    @click="$router.push('/payment-view?tariffGroup=SPLIT')"   
                >SPLIT</div>
                <div 
                    v-if="
                        isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'TEAM') ||
                        isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'TEAM')
                    "
                    @click="$router.push('/payment-view?tariffGroup=TEAM')"   
                class="text-[12px] bg-violet-emb rounded-md text-center text-gray-emb px-[3px] py-[2px] w-[100px]">TEAM</div>
            </div>
        </div> -->
        <div v-else-if="currentTarriff?.tarrif_group_name != training.tariff_group_name" class="w-[90%] mx-auto flex flex-col items-center justify-center">
            <div v-if="isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name)" class="text-[#BF637D] text-center px-[30px] text-[13px] mt-[20px]">
                Бажаєте дане тренування списати з Вашого діючого абонементу, чи оплатити його, купивши абонемент з переліку нижче? 
            </div>
            <div v-if="isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name)" class="text-[#BF637D] text-center px-[30px] text-[13px] mt-[200px]">
                Дія Вашого абонементу не поширюється на даний формат тренування. Чи бажаєте придбати абонемент з переліку нижче, щоб здійснити запис на обране заняття?
            </div>
            <div class="w-full flex gap-[10px] mt-[10px]">
                <div 
                    v-if="
                        isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'PERSONAL') ||
                        isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'PERSONAL')
                    "
                    class="text-[12px] bg-rose-emb rounded-md text-center text-gray-emb px-[3px] py-[10px] font-bold w-full"
                    @click="$router.push('/payment-view?tariffGroup=PERSONAL')"
                >Придбати абонемент</div>
                <div 
                    v-if="
                        isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'SPLIT') ||
                        isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'SPLIT')
                    "
                    class="text-[12px] bg-green-emb rounded-md text-center text-gray-emb px-[3px] py-[10px] font-bold w-full" 
                    @click="$router.push('/payment-view?tariffGroup=SPLIT')"   
                >Придбати абонемент</div>
                <div 
                    v-if="
                        isTariffLowRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'TEAM') ||
                        isTariffHighRank(currentTarriff?.tarrif_group_name, training.tariff_group_name) && (training.tariff_group_name == 'TEAM')
                    "
                    @click="$router.push('/payment-view?tariffGroup=TEAM')"   
                class="text-[12px] bg-violet-emb rounded-md text-center text-gray-emb px-[3px] py-[10px] w-full font-bold">Придбати абонемент</div>
            </div>
        </div>

        <button v-if="!(clientAvalaibelBooks <= 0 || currentTarrifDateExpire <= trainingDate) && ((currentTarriff?.tarrif_group_name == 'PERSONAL' && (training.tariff_group_name == 'PERSONAL' || training.tariff_group_name == 'SPLIT' || training.tariff_group_name == 'TEAM')) || (currentTarriff?.tarrif_group_name == 'SPLIT' && (training.tariff_group_name == 'SPLIT' || training.tariff_group_name == 'TEAM')) || (currentTarriff?.tarrif_group_name == 'TEAM' && training.tariff_group_name == 'TEAM'))" @click="addClientBook" class="bg-green-emb disabled:opacity-50 mx-auto absolute bottom-[30px] left-[50%] translate-x-[-50%] w-[363px] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center mb-[16px]">
            <div v-if="currentTarriff?.tarrif_group_name != training.tariff_group_name && !(currentTarrifDateExpire <= trainingDate && clientAvalaibelBooks > 0)" class="w-full text-[13px] text-gray-emb font-extrabold">Здійснити запис списавши заняття з наявного абонементу</div>
            <div v-else class="w-full text-[13px] text-gray-emb font-extrabold">Підтвердити</div>
        </button>
    </div>
    <div v-else class="w-full h-full fixed pt-[10px] bottom-0 z-[999] bg-[#FFF]">
        <div class="w-full h-full flex items-center justify-center">
            <div class="w-[50px] h-[50px] border-[5px] border-[#BF637D] rounded-full border-t-transparent animate-spin"></div>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted } from 'vue';
    import { useRouter } from 'vue-router';
    import { useMainStore } from '@/mobileApp/store/mainStore';
    import { deleteClientTrainingById, addClientTrainingBook, getClientsTrainingByClientId, getAllGroupAndItsTariffs, getAllClientTariffsByClientId } from '@/mobileApp/services/apiRequests';
    import SquircleComponent from '@/mobileApp/components/SquircleComponent.vue';

    export default {
        name: 'PlanedTrainingView',

        props: {
            training: {
                type: Object,
                default: () => {}
            },
            currentTarriffId : {
                type: Number,
                default: () => {}
            },
            tarriffsCount: {
                type: Number,
                default: 0
            }
        },

        setup(props, { emit }) {
            const apiURL = ref(process.env.VUE_APP_API_URL);
            const store = useMainStore();
            const router = useRouter();

            const clientBooks = ref([]);
            const allTarriffsGroups = ref([]);
            const currentTarriffGroup = ref(null);
            const currentGroupTarriffs = ref([]);
            const clientAvalaibelBooks = ref(0);
            const currentClientsTariffs = ref([]);
            
            const currentTarriff = ref(null);
            const currentTarrifDateExpire = ref(null);

            const trainingDate = ref(new Date(props.training.date).getTime());

            const loading = ref(false);

            onMounted(async () => {
                allTarriffsGroups.value = (await getAllGroupAndItsTariffs()).data
                console.log('allTarriffsGroups.value', props.training)
                clientBooks.value = (await getClientsTrainingByClientId(store.student.student_id)).data

                currentTarriffGroup.value = allTarriffsGroups.value.filter(group => {
                    return group.group_id === props.training.tariff_group_id
                })[0]

                currentClientsTariffs.value = (await getAllClientTariffsByClientId(store.student.student_id)).data
                // if (!props.training.superposition) {
                //     currentClientsTariffs.value = currentClientsTariffs.value.filter(tariff => {
                //         return tariff.tarrif_group_id === props.training.tariff_group_id
                //     })
                // } else {
                //     currentClientsTariffs.value = currentClientsTariffs.value
                // }

                let clientBooksWithCurrentTarriffGroup = []
                console.log('currentTarriffGroup.value', currentTarriffGroup.value)
                if (currentTarriffGroup.value) {
                    currentGroupTarriffs.value = currentTarriffGroup.value.tariffs

                    clientBooksWithCurrentTarriffGroup = clientBooks.value.filter(book => {
                        return currentGroupTarriffs.value.find(tarriff => {
                            return tarriff.tariff_id === book.tariff_id
                        })
                    })
                } else {
                    currentGroupTarriffs.value = [...allTarriffsGroups.value[0].tariffs, ...allTarriffsGroups.value[1].tariffs]
                    console.log('324234', currentGroupTarriffs.value)

                    clientBooksWithCurrentTarriffGroup = clientBooks.value.filter(book => {
                        return currentGroupTarriffs.value.find(tarriff => {
                            return tarriff.tariff_id === book.tariff_id
                        })
                    })
                }

                clientBooksWithCurrentTarriffGroup = clientBooksWithCurrentTarriffGroup.filter(book => {
                    return book.status === 'planed'
                })

                clientAvalaibelBooks.value = currentClientsTariffs.value.reduce((acc, curr) => {
                    return acc + curr.training_remains
                }, 0)

                console.log('clientAvalaibelBooks.value', clientAvalaibelBooks.value)
                console.log('clientBooksWithCurrentTarriffGroup', clientBooksWithCurrentTarriffGroup)
                console.log('clientBooksWithCurrentTarriffGroup.length', clientBooksWithCurrentTarriffGroup.length)

                clientAvalaibelBooks.value = clientAvalaibelBooks.value - clientBooksWithCurrentTarriffGroup.length + 1

                // if (props.training.superposition) {
                //     currentTarriff.value = store.clientTariffs[props.currentTarriffId]    
                // } else {
                //     currentTarriff.value = store.clientTariffs.find(tariff => tariff.tarrif_group_id === props.training.tariff_group_id);
                // }

                currentTarriff.value = currentClientsTariffs.value[props.currentTarriffId - 1]
                console.log('currentTarriff.value', currentTarriff.value)
                console.log('props.currentTarriffId', props.currentTarriffId)

                // console.log('currentTarriff.value.date_expired', new Date(currentTarriff.value.date_expired).setHours(23, 59, 59, 999))
                currentTarrifDateExpire.value = new Date(currentTarriff.value.date_expired).setHours(23, 59, 59, 999);

                console.log('currentTarrifDateExpire.value', currentTarrifDateExpire.value)
                console.log('trainingDate.value', trainingDate.value)
            });

            const addClientBook = async () => {
                let currentBookTarrif = null
                loading.value = true;
                console.log('props.currentTarriffId', props.currentTarriffId);
                if (props.training.superposition) {
                    currentBookTarrif = store.clientTariffs[props.currentTarriffId]    
                } else {
                    currentBookTarrif = store.clientTariffs.find(tariff => tariff.tarrif_group_id === props.training.tariff_group_id);
                }                

                if (!currentBookTarrif) {
                    // alert('Ви не можете записатись на це тренування, так як у вас немає підходящого абонементу');
                    // return;
                    currentBookTarrif = currentClientsTariffs.value[props.currentTarriffId - 1]
                }
                const response = await addClientTrainingBook({
                    training_id: props.training.training_id,
                    client_id: store.student.student_id,
                    status: "planed",
                    date: props.training.date,
                    start_time: props.training.start_time,
                    end_time: props.training.end_time,

                    tariff_id: currentBookTarrif.tariff_id,
                    tariff_price: currentBookTarrif.tariff_price,
                    tariff_training_count: currentBookTarrif.tariff_training_count,
                    client_tariff_id: currentBookTarrif.client_tariff_id,

                    client_label: store.student.student_name + ' ' + store.student.student_surname,
                    client_photo: store.student.photo,
                    client_phone: store.student.phone,
                });

                router.go();
            }

            const parseType = (type) => {
                switch (type) {
                    case 'yoga':
                        return 'йога'
                    case 'barre':
                        return 'барре'
                    case 'pilates_ref':
                        return 'пілатес(реф)'
                    case 'pilates_mat':
                        return 'пілатес(мат)'
                    case 'straching':
                        return 'стретчинг'
                    case 'pilates_preg':
                        return 'пілатес(вагітні)'
                    case 'bodysculpt':
                        return 'бодіскульпт'
                    case 'vinyasa_flow':
                        return 'вінʼяса флоу'
                    case 'hatha_yoga':
                        return 'хатха йога'
                    case 'fly_stretching':
                        return 'fly-стретчинг'
                    case 'bfb':
                        return 'BFB'
                }
            }

            const isTariffHighRank = (tariffGroupName, trainingGroupName) => {
                if (tariffGroupName === 'PERSONAL') {
                    if (trainingGroupName === 'PERSONAL' || trainingGroupName === 'SPLIT' || trainingGroupName === 'TEAM') {
                        return true
                    }
                } 

                if (tariffGroupName === 'SPLIT') {
                    if (trainingGroupName === 'SPLIT' || trainingGroupName === 'TEAM') {
                        return true
                    }
                }

                if (tariffGroupName === 'TEAM') {
                    if (trainingGroupName === 'TEAM') {
                        return true
                    }
                }
                return false
            }

            const isTariffLowRank = (tariffGroupName, trainingGroupName) => {
                if (tariffGroupName === 'PERSONAL') {
                    return false
                } 

                if (tariffGroupName === 'SPLIT') {
                    if (trainingGroupName === 'PERSONAL') {
                        return true
                    }
                }

                if (tariffGroupName === 'TEAM') {
                    if (trainingGroupName === 'SPLIT' || trainingGroupName === 'PERSONAL') {
                        return true
                    }
                }
                return true
            }

            const translateGroupName = (name) => {
                // Implement your translation logic here
                if (name === 'PERSONAL') {
                    return 'ІНДИВ';
                } else if (name === 'SPLIT') {
                    return 'ДУО';
                } else if (name === 'TEAM') {
                    return 'ГРУПОВЕ';
                }
            }

            return {
                apiURL,
                addClientBook,
                parseType,
                clientAvalaibelBooks,
                currentTarrifDateExpire,
                trainingDate,
                loading,
                currentTarriff,

                isTariffHighRank,
                isTariffLowRank,
                translateGroupName,
            }
        },

        components: {
            SquircleComponent
        }
    }
</script>

<style lang="scss" scoped>

</style>